import routes from './routes';

export default {
    routes: routes,
};



// WEBPACK FOOTER //
// ./src/router/index.js